import { ReactElement, useMemo } from 'react';
import { CloseOutlined, MenuOutlined, UserOutlined } from '@ant-design/icons';
import { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Dropdown } from 'common/components/antd/Dropdown/Dropdown';
import { Logo } from 'common/components/Logo/Logo';
import { Centered } from 'common/components/Utilities/Centered';
import { ELocalStorage } from 'common/enums/local-storage.enum';
import { setToLocalstorage } from 'common/utils/local-storage.utils';
import { authLogoutFlow } from 'domains/auth/services/auth.service';
import { SContainer, SBellFilled, SUserIconContainer, SBurgerMenuButton } from './header.style';
import { dashboardSidebarHook } from '../../hooks/dashboard-sidebar.hook';

const HeaderComponent = (): ReactElement => {
  const sidebar = dashboardSidebarHook();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const logout = async (): Promise<void> => {
    try {
      await authLogoutFlow(navigate);
    } catch (error) {
      console.error(error);
    }
  };

  const dropdownMenu = useMemo<MenuProps>(
    () => ({
      onClick: ({ key }): void => {
        if (key === 'logout') {
          // todo: move it to action
          logout();
        }
      },
      items: [
        {
          label: t('ui.header.button.logout'),
          key: 'logout',
        },
      ],
    }),
    [],
  );

  const burgerMenuToggleCollapsedHandler = (): void => {
    setToLocalstorage(ELocalStorage.MenuCollapsed, !sidebar.collapsed);
    sidebar.setCollapsed(!sidebar.collapsed);
  };

  return (
    <SContainer>
      <Centered>
        <SBurgerMenuButton onClick={burgerMenuToggleCollapsedHandler}>
          {sidebar.collapsed ? <MenuOutlined /> : <CloseOutlined />}
        </SBurgerMenuButton>
        <Logo height="27" />
      </Centered>
      <Centered>
        <SBellFilled />
        <Dropdown menu={dropdownMenu}>
          <SUserIconContainer>
            <UserOutlined />
          </SUserIconContainer>
        </Dropdown>
      </Centered>
    </SContainer>
  );
};

export default HeaderComponent;
